import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import {
  enableProdMode,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  MAT_RIPPLE_GLOBAL_OPTIONS,
  MatNativeDateModule,
  RippleGlobalOptions,
} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { NcIconService } from '@neurocare/ui';
import {
  ILoggingService,
  INSTRUMENTATION_KEY,
  LoggingService,
  MockLoggingService,
} from '@neurocare/utils';
import { environment } from '@patient_environment';

import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    // Zoneless: the app no longer ships zone.js (see polyfills in project.json). Change detection is
    // driven by signals / async pipe / event handlers. All async view state was migrated to signals
    // (chore/patient-signals-migration) first, which this relies on.
    provideZonelessChangeDetection(),
    // paramsInheritanceStrategy: 'always' preserves the old AppRoutingModule forRoot behaviour so
    // child routes (e.g. the assignment fill-out) still inherit :clinicGroupId / :homeId params.
    provideRouter(
      APP_ROUTES,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    // BrowserModule is intentionally NOT imported here: bootstrapApplication provides it
    // implicitly, and importing it again throws NG05100 at startup.
    importProvidersFrom(BrowserAnimationsModule, MatNativeDateModule),
    {
      provide: INSTRUMENTATION_KEY,
      useValue: environment.appInsights.instrumentationKey,
    },
    {
      provide: ILoggingService,
      useFactory: () => {
        return environment.useAppInsights
          ? new LoggingService()
          : new MockLoggingService();
      },
    },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    NcIconService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
